var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovernanceCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5435 12.4203L0 10.8768L4.66667 6.21016L0 1.5435L1.5435 0L6.21016 4.66667L10.8768 0L12.4203 1.5435L7.75366 6.21016L12.4203 10.8768L10.8768 12.4203L6.21016 7.75366L1.5435 12.4203Z",
    fill: "#F43F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceCrossIcon);
export default __webpack_public_path__ + "static/media/GovernanceCrossIcon.dbf14c86661db216f92c79e8238a2657.svg";
export { ForwardRef as ReactComponent };